export default "/images/warning-theme.png?fe0aee3e2d12df0423b6ba0652fff817";